var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.999,
    viewBox: "0 0 14 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2173eb",
    d: "M1,14a1,1,0,0,1-1-1V10.739a1,1,0,0,1,1-1H13a1,1,0,0,1,1,1V13a1,1,0,0,1-1,1Zm9.667-2.13a1,1,0,1,0,1-.913A.96.96,0,0,0,10.667,11.869ZM1,9.13a1,1,0,0,1-1-1V5.87a1,1,0,0,1,1-1H13a1,1,0,0,1,1,1V8.131a1,1,0,0,1-1,1ZM10.667,7a1,1,0,0,0,2,0,1,1,0,0,0-2,0ZM1,4.261a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H13a1,1,0,0,1,1,1V3.261a1,1,0,0,1-1,1Zm9.667-2.13a1,1,0,0,0,2,0,1,1,0,0,0-2,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerSm);
export default __webpack_public_path__ + "static/media/server-sm.503751e41dd4434a1a9de9c6c7728921.svg";
export { ForwardRef as ReactComponent };